import { t } from 'i18next';
import { RAID_METADATA_BY_SLUG } from '../../../../../shared/enums';
import RaidRankingsLoader from '../raidRankingsLoader';
import { RaidRankingsContentFrontpage } from './raidRankingsContentFrontpage';
import apiService from '../../../services/apiService';
import { createActionGetRaidRankings } from '../../../actions/getRaidRankings';
import _ from 'lodash';

export type TRaidExpansionHistoryPaneProps = {
  enabled: boolean;
  expansion: string;
  raidSlugs: string[];
  difficulty: string;
  region: string;
  realm?: string;
};

export function RaidExpansionHistoryPane(props: TRaidExpansionHistoryPaneProps) {
  if (!props.enabled) {
    return null;
  }

  return (
    <>
      <h2 className="slds-m-bottom--small slds-m-top--large">
        <span className="rio-text-title--caps text-raiderio">
          {t('frontpage:section-header-top-expansion-guilds', {
            expansion: t(`common:expansions.${props.expansion}.name`)
          })}
        </span>
        <span className="slds-m-left--small slds-text-title--caps text-white">
          {t('frontpage:difficulty-raid-progress', {
            difficulty: t(`common:difficulty.${props.difficulty}.name`)
          })}{' '}
          ({t('frontpage:seasons-1-to-3')})
        </span>
      </h2>

      <div className="slds-grid slds-wrap slds-grid--pull-padded">
        {props.raidSlugs
          .map((raidSlug) => RAID_METADATA_BY_SLUG[raidSlug])
          .map((raid: (typeof RAID_METADATA_BY_SLUG)[string], index: number) => (
            <div
              key={raid.slug}
              className={`slds-is-relative slds-size--1-of-${Math.max(
                2,
                props.raidSlugs.length
              )} slds-max-small-size--1-of-1 slds-p-horizontal--xx-small`}
            >
              <RaidRankingsLoader
                component={RaidRankingsContentFrontpage}
                limit={5}
                title={`${t(`raids:${raid.slug}.name`)} (S${1 + index})`}
                raid={raid.slug}
                difficulty={props.difficulty}
                region={props.region}
                realm={props.realm || 'all'}
                instanceId={`frontpage:raid:top:${raid.slug}:${props.region}`}
                ignoreErrors={true}
              />
            </div>
          ))}
      </div>
    </>
  );
}

(RaidExpansionHistoryPane as any).preloadComponentActions = async (
  props: TRaidExpansionHistoryPaneProps,
  params: any
) => {
  if (!props.enabled) {
    return [];
  }

  const promises: any = [];

  props.raidSlugs.forEach((raidSlug: string, index: number) => {
    promises.push(
      new Promise((resolve, reject) => {
        const loadParams: any = {
          raid: raidSlug,
          difficulty: props.difficulty,
          region: props.region,
          realm: props.realm || 'all',
          limit: 5,
          faction: '',
          page: 0,
          recent: false
        };

        apiService.getRaidInstanceRankings(loadParams, (err, data: any) => {
          if (err) {
            reject(err);
          } else {
            resolve([createActionGetRaidRankings(`frontpage:raid:top:${raidSlug}:${props.region}`, data.raidRankings)]);
          }
        });
      })
    );
  });

  return _.flatten(await Promise.all(promises));
};
